module.exports = __webpack_public_path__ + "img/8825f9e77655b58539eba0f7baa03e57.d459d0c0.jpg";